import { postApi } from "../../services/api/globalApi";
import {
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";

import Button from "../../components/common/button/Button";
import Title from "../../components/common/title/Title";
import ImageUploader from "react-images-upload";
import { useRef, useState } from "react";
import { fileUrl } from "../../services/config";
import { useNavigate } from "react-router";

export default function File() {
  const [images, setImages] = useState([]);
  const [progress, setProgress] = useState(null);
  const navigate = useNavigate();
  console.log(images);

  const myRef = useRef();

  const formHandler = async (e) => {
    e.preventDefault()
    console.log(images);
    for (let i = 0; i < images.length; i++) {
      let formData = new FormData();
      formData.append("file", images[i]);
      const path = `${fileUrl}file`;
      try {
        await postApi({
          path,
          body: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        successMessage(`فایل ${images[i].name} با موفقیت آپلود شد.`);
        // setProgress(null);
      } catch (error) {
        console.log(error);
      }
    }
    navigate("/file-list");
  };

  return (
    <form
      onSubmit={formHandler}
      className="bg-white dark:bg-gray-900 rounded-3xl p-6"
    >
      <Title title={"آپلود فایل"} />

      <div className="mt-6">
        <ImageUploader
          type="file"
          withIcon={true}
          withPreview={true}
          buttonText="انتخاب عکس"
          label="png - gif - jpg حداکثر حجم عکس 1 مگابایت | فرمت عکس ها "
          fileSizeError="حجم عکس بیش از حد مجاز است"
          fileTypeError="فرمت  عکس پشتیبانی نمیشود."
          imgExtension={[".jpg", ".gif", ".png", ".gif"]}
          ref={myRef}
          onChange={(e) => {
            console.log(e);
            setImages(e);
          }}
          maxFileSize={5242880}
        />

        {progress && (
          <div className="w-11/12mx-auto my-3 bg-gray-200 rounded-full dark:bg-gray-700">
            <div
              className="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
              style={{ width: `${progress}%` }}
            >
              {" "}
              {progress || 0}%
            </div>
          </div>
        )}

        <div className="flex flex-col gap-y-2">
          <div className="mt-6">
            <Button text={"آپلود"} type={"success"} />
          </div>
        </div>
      </div>
    </form>
  );
}
